export const toiSignedMandatory = {
  async: false,
  validate: function(data: any) {
    const entityData = data.original
    if (entityData.toi_signed == "1" && !entityData.toi) {
      throw Error("Insira um TOI")
    }
    return true
  },
}
